import Pagination from '@/util/pagination'

export default function () {
  return {
    pagination: new Pagination(),
    categories: [],
    showDeleteDialog: false,
    deletingId: null,
  }
}
